module.exports = {"name":"Image","description":"A single image block","fields":[{"name":"data.title","label":"Title","type":"text"},{"name":"data.picture","label":"Picture","type":"picture","valueType":"object"},{"name":"data.lightbox","label":"Show in lightbox","type":"toggle"},{"name":"data.downloadable","label":"Downloadable","type":"toggle"},{"name":"data.background","label":"Background","type":"toggle"}]}


//////////////////
// WEBPACK FOOTER
// ./components/blocks/definitions/image.json
// module id = 671
// module chunks = 185 187